export const removeEmptyValuesFromObject = (
  obj: Record<string, unknown>,
): Record<string, unknown> => {
  const finalObj = {};

  Object.keys(obj).forEach((key) => {
    if (obj[key] && typeof obj[key] === 'object') {
      const nestedObj = removeEmptyValuesFromObject(
        obj[key] as Record<string, unknown>,
      );

      if (Object.keys(nestedObj).length) {
        Object.assign(finalObj, { [key]: nestedObj });
      }
    }
    if (
      (obj[key] && typeof obj[key] !== 'object') ||
      typeof obj[key] === 'boolean'
    ) {
      Object.assign(finalObj, { [key]: obj[key] });
    }
  });

  return finalObj;
};
